import { module } from 'modujs';
import Hls from 'hls.js';

const HLS_TYPE = 'application/vnd.apple.mpegurl';

export default class extends module {
    constructor(m) {
        super(m);

        this.onManifestParsed = this.onManifestParsed.bind(this);
    }

    init() {
        this.replayInlineScript();
        this.initHls();
    }

    replayInlineScript() {
        const script = this.el.querySelector('script')
        if(script) {
            const newScript = document.createElement('script')
            newScript.textContent = script.textContent;
            script.remove();
            this.el.appendChild(newScript);
        }
    }

    initHls() {
        const source = this.activeSource();
        if (!source || !this.isHls(source)) return;
        if (!Hls.isSupported()) return;
        if (this.el.canPlayType(HLS_TYPE) == 'probably') return;

        this.manifestReady = false;
        this.hls = new Hls();
        this.hls.on(Hls.Events.MANIFEST_PARSED, this.onManifestParsed);
        this.hls.loadSource(source.src);
        this.hls.attachMedia(this.el);
    }

    activeSource() {
        const sources = this.el.querySelectorAll('source');

        for (let i = 0; i < sources.length; i++) {
            const media = sources[i].getAttribute('media');
            if (!media || window.matchMedia(media).matches) return sources[i];
        }

        return null;
    }

    isHls(source) {
        const type = (source.getAttribute('type') || '').toLowerCase();
        const src = source.getAttribute('src') || '';

        return type === HLS_TYPE || type === 'application/x-mpegurl' || src.indexOf('.m3u8') !== -1;
    }

    onManifestParsed() {
        this.manifestReady = true;

        if (this.pendingPlay && this.el.paused) {
            this.pendingPlay = false;
            this.el.play();
        }
    }

    playWhenReady() {
        if (this.hls && !this.manifestReady) {
            this.pendingPlay = true;
            return;
        }

        this.el.play();
    }

    toggle(e) {
        if(e.target != this.el) return;

        if(e.way === "enter") {
            if(this.el.paused) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.playWhenReady();
                }, 200);
            }
        } else {
            clearTimeout(this.timeout);
            this.pendingPlay = false;

            if(!this.el.paused) {
                this.el.pause();
            }
        }
    }

    destroyHls() {
        if (this.hls) {
            this.hls.destroy();
            this.hls = null;
        }
    }

    destroy() {
        clearTimeout(this.timeout);
        this.pendingPlay = false;
        this.destroyHls();
        super.destroy();
    }
}
